<template>
    <div class="bg-BAT bg-delete-account text-bat h-100">
        <div class="container py-4">
            <div class="backBtnReto pt-4 px-3 d-block d-md-none">
                <a href="/home-bat"> < Regresar</a>
            </div>
            <div class="breadcrumbs py-5">
                <a href="/home-bat">Inicio</a>
                <a class="link" href="#"> <strong>Eliminar Cuenta</strong> </a>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-md-6 col-lg-6 order-2 order-md-1 order-lg-1 py-2 py-md-0 py-lg-0">
                    <h2 class="text-title-bat text-indigo-darkness">¡No nos gustaría despedirnos de ti!</h2>
                    <p class="fs-5">Al “Darte de baja” perderás:</p>
                    <ul>
                        <li class="mb-4 fs-6">Tus puntos acumulados y la opción de redimirlos en: bonos digitales, productos para el hogar, tecnología, tu negocio.</li>
                        <li class="mb-4 fs-6">Nuestras promociones, esos descuentos que te damos y en los que te notificamos a través de esta plataforma.</li>
                        <li class="mb-4 fs-6">Tips, consejos o lecciones de aprendizaje para organizar y mejorar tu negocio.</li>
                        <li class="mb-4 fs-6">Aliados que hoy te brindan descuentos para que puedas disfrutar en comida, ropa, entretenimiento y mucho más.</li>
                    </ul>
                    <div class="row justify-content-evenly mt-5">
                        <div class="col-6 col-md-4 col-lg-4 d-flex  justify-content-center" >
                            <a href="/home-bat" class="btn btn-link text-secondary">Cancelar</a>
                        </div>
                        <div class="col-6 col-md-4 col-lg-4 d-flex justify-content-center">
                            <button @click="modal_confirm = true"
                                    class="btn btnBlue">
                                Darte de Baja
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 order-1 order-md-2 order-lg-2 py-4 py-md-0 py-lg-0">
                    <img src="/img/brand/delete_img.svg" alt="delete_img" class="w-100">
                </div>
            </div>

        </div>
        

        <!-- Mensaje de Confirmacion START -->

        <el-dialog
            :visible.sync="modal_confirm"
            :width="$mq ==='sm' ? '95%' : '35%'"
            :show-close="false">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break">
                <img class="w-25 mb-2" style="width: 60px !important;" src="/img-version2/modal/alert-icon.svg" alt="alert">
                <h4 class="text-indigo-darkness">¿Estás segura/o de que quieres desvincularte del programa?</h4>
                <span class="my-2 fs-6">Ten en cuenta que al desvincularte perderás la posibilidad de acumular puntos, hacer seguimiento a tus ventas y disfrutar de las alianzas y demás beneficios que Conecta2 te brinda.</span>
                <span class="my-3 fs-6">Según la Ley de Protección de Datos Personales una vez lo hagas, <strong>tu usuario y demás información desaparecerán de la plataforma</strong>.</span>
                <span slot="footer" class="my-4 dialog-footer d-flex justify-content-evenly w-100">
                    <button class="btn btn-link text-secondary " @click="modal_confirm = false">Cancelar</button>
                    <button v-if="!send_delete" id="boton-dar-de-baja" title="dar de baja" class="btn btnBlue" type="primary" :disabled="send_delete" @click="confirmDelete">Sí, darme de baja</button>
                    <button v-else class="btn btnBlue disabled" type="primary" :disabled="send_delete" >Sí, darme de baja</button>
                </span>
            </div>            
        </el-dialog>

        <el-dialog
            :visible.sync="delete_confirm"
            :width="$mq ==='sm' ? '95%' : '35%'"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            :show-close="false">
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break">
                <img class="w-25 mb-2" style="width: 60px !important;" src="/img-version2/modal/alert-icon.svg" alt="alert">
                <h4 class="text-indigo-darkness">Tus datos han sido eliminados</h4>
                <span class="my-2 fs-6">Tu cuenta ha sido cancelada.</span>                
                <span slot="footer" class="my-4 dialog-footer d-flex justify-content-center w-100">
                    <button class="btn btnBlue" type="primary" @click="acceptDelete">Aceptar</button>
                </span>
            </div>            
        </el-dialog>

        <!-- Mensaje de Confirmacion END -->


    </div>

    
</template>

<script>
    export default {
        data() {
            return {
                loading: 0,
                modal_confirm: false,
                delete_confirm: false,
                send_delete: false
            };
        },
        mounted() {
        },
        methods: {
            confirmDelete(){
                this.send_delete = true; 
                if(this.send_delete){
                    this.loading++
                    axios.post('/account/confirm-delete', {})
                     .then(
                        ({data}) => {
                            if(data.status === 'success'){
                                this.modal_confirm = false;  
                                this.send_delete = false;                       
                                this.delete_confirm = true;
                            }
                        })
                }
            },
            acceptDelete(){
                window.location.href = '/'
            }
        },
        
    }
</script>
